/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable i18next/no-literal-string */
import { Breadcrumbs, Grid, Typography, Button } from '@mui/material';
import '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import FeedbackContainer from './FeedbackContainer';
import StyledFormTitle from '../../../styles/form-title';
import './FeedbackForm.css';

const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;
export const FeedbackDetail = () => {
    const [troubleshootingRating, setTroubleshootingRating] = useState(0);
    const [troubleshootingComment, setTroubleshootingComment] = useState('');
    const [classContentRating, setClassContentRating] = useState(0);
    const [classContentComment, setClassContentComment] = useState('');
    const [sentimentRating, setSentimentRating] = useState(0);
    const [sentimentComment, setSentimentComment] = useState('');
    const [userSentimentRating, setUserSentimentRating] = useState(0);
    const [userSentimentComment, setUserSentimentComment] = useState('');

    const feedbackData = {
        troubleshootingRating,
        troubleshootingComment,
        sentimentRating,
        sentimentComment,
        userSentimentRating,
        userSentimentComment,
        classContentRating,
        classContentComment
    };
    console.log(feedbackData);

    console.log('FeedbackDetail');

    const handleStarHover = (rating, category) => {
        if (category === 'troubleshooting') {
            setTroubleshootingRating(rating);
        } else if (category === 'classContent') {
            setClassContentRating(rating);
        } else if (category === 'sentiment') {
            setSentimentRating(rating);
        } else if (category === 'usersentiment') {
            setUserSentimentRating(rating);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const feedbackData1 = {
            troubleshootingRating,
            troubleshootingComment,
            sentimentRating,
            sentimentComment,
            userSentimentRating,
            userSentimentComment,
            classContentRating,
            classContentComment
        };
        console.log(feedbackData1);
        setTroubleshootingComment('');
        setSentimentComment('');
        setUserSentimentComment('');
        setClassContentComment('');
    };

    const { t } = useTranslation('portal');

    function handleStarClick(rating: number, arg1: string): void {
        throw new Error('Function not implemented.');
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/portal/feedback">{t('feedback-page.feedback')}</Link>
            </Breadcrumbs>
            <h2 style={{ textAlign: 'center' }}>{t('we-want-your-feedback')}</h2>
            <form>
                <div>
                    <label>How has AI helper performed in troubleshooting?</label>
                    <div>
                        <fieldset>
                            {/* Star rating for class content */}
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((rating) => (
                                    <span
                                        key={rating}
                                        className={
                                            // eslint-disable-next-line no-nested-ternary
                                            rating <= troubleshootingRating ? 'star active' : rating <= troubleshootingRating ? 'star prior-active' : 'star'
                                        }
                                        onClick={() => handleStarHover(rating, 'troubleshooting')}
                                        onMouseEnter={() => handleStarHover(rating, 'troubleshooting')}
                                    >
                                        <FontAwesomeIcon icon={faStar} />
                                    </span>
                                ))}
                            </div>
                        </fieldset>
                    </div>
                </div>
                <br/>
                <div>
                    <label>Comments (optional)</label><br/>
                    <textarea
                        value={troubleshootingComment}
                        onChange={(e) => setTroubleshootingComment(e.target.value)}
                        style={{ width: '100%', height: '100px' }}
                    />
                </div>
                <Button style={{ backgroundColor: '#4739e7', color: '#fff', width: '150px', height: '40px' }}>{t('Submit')}</Button>
                <br/><br/><br/>
                <div>
                    <label>How has AI helper performed in analyzing sentiment of classes?</label>
                    <div>
                        <fieldset>
                            {/* Star rating for class content */}
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((rating) => (
                                    <span
                                        key={rating}
                                        className={
                                            // eslint-disable-next-line no-nested-ternary
                                            rating <= sentimentRating ? 'star active' : rating <= sentimentRating ? 'star prior-active' : 'star'
                                        }
                                        onClick={() => handleStarHover(rating, 'sentiment')}
                                        onMouseEnter={() => handleStarHover(rating, 'sentiment')}
                                    >
                                        <FontAwesomeIcon icon={faStar} />
                                    </span>
                                ))}
                            </div>
                        </fieldset>
                    </div>
                </div>
                <br/>
                <div>
                    <label>Comments (optional)</label><br/>
                    <textarea
                        value={sentimentComment}
                        onChange={(e) => setSentimentComment(e.target.value)}
                        style={{ width: '100%', height: '100px' }}
                    />
                </div>
                <Button style={{ backgroundColor: '#4739e7', color: '#fff', width: '150px', height: '40px' }}>{t('Submit')}</Button>
                <br/><br/><br/>
                <div>
                    <label>How has AI helper performed in analyzing sentiment of users?</label>
                    <div>
                        <fieldset>
                            {/* Star rating for class content */}
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((rating) => (
                                    <span
                                        key={rating}
                                        className={
                                            // eslint-disable-next-line no-nested-ternary
                                            rating <= userSentimentRating ? 'star active' : rating <= userSentimentRating ? 'star prior-active' : 'star'
                                        }
                                        onClick={() => handleStarHover(rating, 'usersentiment')}
                                        onMouseEnter={() => handleStarHover(rating, 'usersentiment')}
                                    >
                                        <FontAwesomeIcon icon={faStar} />
                                    </span>
                                ))}
                            </div>
                        </fieldset>
                    </div>
                </div>
                <br/>
                <div>
                    <label>Comments (optional)</label><br/>
                    <textarea
                        value={userSentimentComment}
                        onChange={(e) => setUserSentimentComment(e.target.value)}
                        style={{ width: '100%', height: '100px' }}
                    />
                </div>
                <Button style={{ backgroundColor: '#4739e7', color: '#fff', width: '150px', height: '40px' }}>{t('Submit')}</Button>
                <br/><br/><br/>
                <div>
                    <label>How has AI helper performed in answering questions about Class content?</label>
                    <div>
                        <fieldset>
                            {/* Star rating for class content */}
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((rating) => (
                                    <span
                                        key={rating}
                                        className={
                                            // eslint-disable-next-line no-nested-ternary
                                            rating <= classContentRating ? 'star active' : rating <= classContentRating ? 'star prior-active' : 'star'
                                        }
                                        onClick={() => handleStarHover(rating, 'classContent')}
                                        onMouseEnter={() => handleStarHover(rating, 'classContent')}
                                    >
                                        <FontAwesomeIcon icon={faStar} />
                                    </span>
                                ))}
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div><br/>
                    <label>Comments (optional)</label><br/>
                    <textarea
                        value={classContentComment}
                        onChange={(e) => setClassContentComment(e.target.value)}
                        style={{ width: '100%', height: '100px' }}
                    />
                </div>
                <Button style={{ backgroundColor: '#4739e7', color: '#fff', width: '150px', height: '40px' }}>{t('Submit')}</Button>
            </form>
        </>
    );
};
